import React from 'react';

interface SidebarProps {
  children?: React.ReactNode;
  navigation?: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children, navigation }) => (
  <aside
    className="sidebar"
    aria-label="Assistant navigation"
    style={{
      width: '260px',
      minWidth: '260px',
      background: '#0b0b0b',
      borderRight: '1px solid #2e2e2e',
      padding: '1rem',
      boxSizing: 'border-box',
      overflowY: 'auto',
      overflowX: 'hidden',
    }}
  >
    {navigation}
    {children}
  </aside>
);

export default Sidebar;
